import 'focus-visible'
import 'objectFitPolyfill'

import './components/header'
import './components/hero'
import './components/lightbox'
import './components/hoverVideo'
import './components/timeline'
import './components/newsletter-popup'
import './components/entry-grid-filter'

window.addEventListener('resize',
    window.objectFitPolyfill)

window.objectFitPolyfill()
